import { extendObservable, action } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import { browserHistory } from 'react-router';
import { Roles } from '../../../core/util';
import jsonFormData from 'json-form-data';

const defaultCertificateTemplateLanguage = 'en';

export default class CourseFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      courseId: null,
    });
    this.form.validations = {
      name: [isRequired],
      academicPlan: [isRequired],
      order: [isRequired],
    };
  }

  handleLoad = action((courseId) => {
    this.form.reset();
    if (courseId) {
      this.fetch
        .fetch({
          url: `/courses/${courseId}?expand=academicPlan`,
          apiVersion: 'v2',
        })
        .then(() => {
          if (this.fetch.data) {
            this.form.setInitialValues({
              ...this.fetch.data,
              academicPlan: this.fetch.data.academicPlan.id,
              academicPlanKey: this.fetch.data.academicPlan.key,
              certificate: {
                ...(this.fetch.data.certificate || {}),
                templateLanguage:
                  (this.fetch.data.certificate && this.fetch.data.certificate.templateLanguage) ||
                  defaultCertificateTemplateLanguage,
              },
            });
          }
        });
    } else {
      this.form.setInitialValues({
        certificate: {
          templateLanguage: defaultCertificateTemplateLanguage,
        },
        ...(localStorage.getItem('role') === Roles.DISTRIBUTOR_CONTENT_ADMIN && {
          distributor: localStorage.getItem('distributor'),
        }),
      });
    }
    this.courseId = courseId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const values = {
      ...this.form.getValues(),
    };
    values.certificate = {
      ...(values.certificate || {}),
      templateLanguage:
        (values.certificate && values.certificate.templateLanguage) || defaultCertificateTemplateLanguage,
    };
    if (values.courseHours !== undefined && values.courseHours !== null && values.courseHours !== '') {
      values.courseHours = Number(values.courseHours);
    } else {
      delete values.courseHours;
    }
    if (values.certificate && values.certificate.templateUrl instanceof File) {
      values.template = values.certificate.templateUrl;
      delete values.certificate.templateUrl;
    }
    if (!values.template) {
      delete values.template;
    }
    if (
      values.certificate &&
      (values.certificate.templateUrl === undefined || values.certificate.templateUrl === null)
    ) {
      delete values.certificate.templateUrl;
    }

    const formData = jsonFormData(values, {
      initialFormData: new FormData(),
    });

    const courseId = this.form.getValue('id');
    this.submit
      .fetch({
        method: courseId ? 'put' : 'post',
        url: courseId ? `/courses/${courseId}` : '/courses',
        apiVersion: 'v2',
        body: formData,
      })
      .then(() => {
        if (this.submit.data) {
          const course = this.submit.data;
          this.courseId = course.id;
          this.form.reset();
          this.form.setInitialValues(course);

          browserHistory.replace('/courses');
          NotificationService.addNotification(`Course ${courseId ? 'updated' : 'created'} successfully.`, 'success');
        }
        if (this.submit.error) {
          NotificationService.addNotification(`Error ${courseId ? 'updating' : 'creating'} course.`, 'error');
        }
      });
  });
}
